import { useNavigate } from "react-router-dom";
import APP_URL_CONSTS from "../../navigation/AppUrls";
import { BentoBox } from "../../components/Storybook/BentoBox/BentoBox";
import { SimpleText } from "../../components/Storybook/SimpleText/SimpleText";
import Greetings from "../../components/Storybook/Greeting/Greetings";
import { PromotionalBanner } from "../../components/Storybook/PromotionalBanner/PromotionalBanner";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useAppSelector } from "./../../hooks/reduxhooks";
import { CmsType } from "../../types/enums/CmsType";
import useGetUser from "../../hooks/useGetUser";
import useFetchHomepageData from "../../hooks/CMS/useFetchHomepage";
import CarouselSection from "./CarouselSection/CarouselSection";
import UnumStorySection from "./UnumStorySection/UnumStorySection";
import WidthRestrictor from "../../components/WidthRestrictor/WidthRestrictor";
import GeneralFooter from "components/Footer/GeneralFooter";
import { PardotForm } from "../Pardot/PardotForm";

const Homepage = () => {
    const navigate = useNavigate();
    const { homepageData } = useFetchHomepageData(CmsType.Kontent);
    const callbackFunction = () => {
        window.open(`${homepageData?.promoBanner.link}`);
    };
    const { hasCashPlanAccess, hasEmployerAccess, user } = useGetUser();
    const bentoBoxVariant = hasCashPlanAccess && hasEmployerAccess ? "4" : "3";
    const welcomeComponents = [];

    const isCmsLoading = useAppSelector(
        (state) => state.CmsLoadingSlice.isCmsLoading,
    );

    //#region Welcome components
    welcomeComponents.push(
        isCmsLoading ? (
            <Stack spacing={1} sx={{ height: "100%", width: "100%" }}>
                <Skeleton
                    variant="text"
                    sx={{ fontSize: "25px", height: "100%", width: "100%" }}
                />
                <Skeleton
                    variant="text"
                    sx={{ fontSize: "100px", height: "100%", width: "100%" }}
                />
            </Stack>
        ) : (
            <Greetings
                body={homepageData?.intro.welcomeMessage}
                initialGreeting="Welcome"
                name={user.firstName}
            />
        ),
    );

  // PromotionalBanner component
    welcomeComponents.push(
        isCmsLoading ? (
            <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : (
            <PromotionalBanner
                header={homepageData?.promoBanner.title ?? ""}
                headerAltText={homepageData?.promoBanner.title ?? ""}
                image={homepageData?.promoBanner.imageUrl ?? ""}
                subHeader={homepageData?.promoBanner.subtitle ?? ""}
                CallBack={homepageData?.promoBanner.link ? callbackFunction : undefined}
            />
        ),
    );

    // SimpleText component for GroupClaimsAccess
    if (hasEmployerAccess) {
        welcomeComponents.push(
            isCmsLoading ? (
                <Skeleton variant="rounded" width={700} height={250} />
            ) : (
                <SimpleText
                    RedirectCallBack={() => {
                        navigate(`${APP_URL_CONSTS.CLAIMS}`);
                    }}
                    body={homepageData?.groupRiskProductPromo.subtitle ?? ""}
                    initialGreetings={homepageData?.groupRiskProductPromo.title ?? ""}
                    variant="primary"
                />
            ),
        );
    }
    // SimpleText component for CashplanAccess
    if (hasCashPlanAccess) {
        welcomeComponents.push(
            isCmsLoading ? (
                <Skeleton variant="rounded" width={700} height={250} />
            ) : (
                <SimpleText
                    RedirectCallBack={() => {
                        window.open(
                            process.env.REACT_APP_CASHPLAN_REDIRECT_URL
                                ? process.env.REACT_APP_CASHPLAN_REDIRECT_URL
                                : "/error",
                            "_blank",
                        );
                    }}
                    body={homepageData?.cashPlanProductPromo.subtitle ?? ""}
                    initialGreetings={homepageData?.cashPlanProductPromo.title ?? ""}
                    variant={
                        process.env.REACT_APP_CASHPLAN_ACTIVE === "true"
                            ? "secondary"
                            : "disabled"
                    }
                />
            ),
        );
    }
    // #endregion

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "white",
                }}
            >
                {hasEmployerAccess && <PardotForm user={user} />}
                <WidthRestrictor padding="40px">
                    <BentoBox variant={bentoBoxVariant}>{welcomeComponents}</BentoBox>
                </WidthRestrictor>
                <WidthRestrictor backgroundColor="rgb(248, 248, 248)" padding="40px">
                    <CarouselSection
                        isCmsLoading={isCmsLoading}
                        carouselSectionData={homepageData?.CarouselSection}
                    />
                </WidthRestrictor>
                <WidthRestrictor
                    padding="40px"
                    style={{ display: "flex", flexDirection: "column", gap: "80px" }}
                >
                    <UnumStorySection
                        isCmsLoading={isCmsLoading}
                        UnumStory={homepageData?.UnumStory}
                        HealthCashPlan={homepageData?.HealthCashPlanStory}
                        hasCashPlanAccess={hasCashPlanAccess}
                        hasEmployerAccess={hasEmployerAccess}
                    />
                </WidthRestrictor>
            </div>
            <GeneralFooter />
        </>
    );
};

export default Homepage;
